import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { message } from "antd";
import drEasyApi from "../Api/Customapi";

// Query keys
export const EXTERNAL_CONSULTANTS_QUERY_KEY = ["external-consultants"];

// Get all external consultants
export const useGetExternalConsultants = (params = {}) => {
  return useQuery({
    queryKey: [...EXTERNAL_CONSULTANTS_QUERY_KEY, params],
    queryFn: async () => {
      const res = await drEasyApi.get("/api/ExternalConsultants", {
        params: {
          pageNumber: params.pageNumber || 1,
          pageSize: params.pageSize || 100,
          searchText: params.searchText || "",
        },
      });
      return res.data || [];
    },
    onError: (error) => {
      message.error(error.response?.data[0] || "Failed to fetch consultants");
    },
  });
};

// Get external consultant by ID
export const useGetExternalConsultantById = (id) => {
  return useQuery({
    queryKey: [...EXTERNAL_CONSULTANTS_QUERY_KEY, id],
    queryFn: async () => {
      const res = await drEasyApi.get(`/api/ExternalConsultants/${id}`);
      return res.data || null;
    },
    enabled: !!id,
    onError: (error) => {
      message.error(error.response?.data[0] || "Failed to fetch consultant");
    },
  });
};

// Create external consultant mutation
export const useCreateExternalConsultant = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (consultantData) => {
      return await drEasyApi.post("/api/ExternalConsultants", consultantData);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(EXTERNAL_CONSULTANTS_QUERY_KEY);
      message.success("Consultant created successfully");
    },
    onError: (err) => {
      const errorMessage = err?.response?.data[0] || "Failed to create consultant";
      message.error(errorMessage);
    },
  });
};

// Update external consultant mutation
export const useUpdateExternalConsultant = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, ...consultantData }) => {
      return await drEasyApi.put(`/api/ExternalConsultants/${id}`, consultantData);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(EXTERNAL_CONSULTANTS_QUERY_KEY);
      message.success("Consultant updated successfully");
    },
    onError: (err) => {
      const errorMessage = err?.response?.data[0] || "Failed to update consultant";
      message.error(errorMessage);
    },
  });
};

// Delete external consultant mutation
export const useDeleteExternalConsultant = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (consultantId) => {
      return await drEasyApi.delete(`/api/ExternalConsultants/${consultantId}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(EXTERNAL_CONSULTANTS_QUERY_KEY);
      message.success("Consultant deleted successfully");
    },
    onError: (err) => {
      const errorMessage = err?.response?.data[0] || "Failed to delete consultant";
      message.error(errorMessage);
    },
  });
};